import { Typography } from '@workspace/ui/components/Typography';

import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import { company } from '~/company/Company';
import type { ProductPropertiesValue } from '~/types/Product/interface';
import styles from './ProductPropertyFilter.module.scss';

const TitleComponent = company.match({
  mcosmetic: Typography.Text200Medium,
  default: Typography.Text100Medium,
});

type Props = {
  filter: ProductPropertiesValue;
  handleChangeOffer: (sku: string) => () => void;
  name?: string;
  withTitle?: boolean;
  classes?: {
    filterListContainerClassName?: string;
    filterListClassName?: string;
    filterItemClassName?: string;
    itemStateClassNames?: {
      passed?: string;
      empty?: string;
      colorList?: string;
    };
  };
};

const ProductPropertyFilter = ({
  filter,
  handleChangeOffer,
  name,
  withTitle = true,
  classes,
}: Props) => {
  const selectedChoice = filter.choices.find((i) => i.selected);

  const {
    filterListContainerClassName,
    filterListClassName,
    filterItemClassName,
    itemStateClassNames,
  } = classes || {};

  const {
    passed = styles.passed,
    empty = styles.empty,
    colorList = styles.round,
  } = itemStateClassNames || {};

  return (
    <div
      className={cn(styles.filterListContainer, filterListContainerClassName)}
    >
      {withTitle && (
        <TitleComponent className={styles.filterListTitle}>
          {filter.name}:{' '}
          <span className={styles.filterListValue}>
            {selectedChoice?.label}
          </span>
        </TitleComponent>
      )}
      <div className={cn(styles.filterList, filterListClassName)}>
        {filter.choices.map((choice) => {
          return (
            <label
              className={cn(
                styles.filterListItem,
                !choice.sellable && passed,
                !choice.sku && empty,
                filter.type === 'colorList' && colorList,
                filterItemClassName,
              )}
              style={
                filter.type === 'colorList'
                  ? { backgroundColor: choice.value.toString() }
                  : {}
              }
              key={choice.value}
              data-choice-value={choice.value}
            >
              <input
                data-radio={choice.label}
                type="radio"
                name={`${filter.code}_${name ?? ''}`}
                id={`${choice.value.toString()}`}
                value={`${choice.value.toString()}`}
                checked={choice.selected}
                onChange={() => {
                  if (choice.sku) {
                    handleChangeOffer(choice.sku)();
                  }
                }}
              />
              {filter.type !== 'colorList' && <span>{choice.label}</span>}
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default observer(ProductPropertyFilter);
